<template>
  <section>
    <div class="h-comment" testek="comment">
      <div class="title-comment">Bình luận</div>
      <a-comment>
        <template #avatar>
          <div class="border-avatar">
            <a-avatar class="icon-avatar-user" alt="Han Solo" />
          </div>
        </template>
        <template #content>
          <a-form-item>
            <a-input
              v-model:value="params.name"
              :rows="4"
              placeholder="Người bình luận"
              class="input-comment"
            />
          </a-form-item>
          <a-form-item>
            <a-textarea
              v-model:value="params.comment"
              :rows="4"
              placeholder="Viết bình luận"
              class="input-comment"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              html-type="submit"
              :loading="submitting"
              type="primary"
              @click="handleSubmit"
            >
              Bình luận
            </a-button>
          </a-form-item>
        </template>
      </a-comment>
      <div class="comments">
        <div class="comment" v-for="(item, index) in comments" :key="index">
          <div class="flex">
            <div class="comment-content-info w-full">
              <div class="flex">
                <div class="border-avatar h-10 w-10 mr-4">
                  <a-avatar class="icon-avatar-user" alt="Han Solo" />
                </div>
                <div class="flex">
                  <div class="author">{{ item.author }}</div>
                  <div class="comment-date ml-8" v-if="item.commentDate">
                    {{ $commonFunc.formatDate(item.commentDate) }}
                  </div>
                </div>
              </div>
              <div class="mt-4 comment-content">
                {{ item.content }}
              </div>
            </div>
          </div>
          <div :class="index == comments.length - 1 ? '' : 'distance-comment'"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "HComment",
  props: {
    comments: [],
  },
  data() {
    return {
      comment: null,
      submitting: false,
      params: {
        comment: "",
        name: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      const me = this;
      if (!me.params.name) {
        me.$messageNotification.messageNotification(
          "Tên người bình luận không được để trống",
          "warning"
        );
        return;
      }
      if (!me.params.comment) {
        me.$messageNotification.messageNotification("Bình luận để trống", "warning");
        return;
      }

      me.submitting = true;
      setTimeout(() => {
        me.submitting = false;
        // me.comments = [
        //     {
        //         author: 'Han Solo',
        //         avatar: 'https://joeschmoe.io/api/v1/random',
        //         content: me.comment,
        //         datetime: me.$commonFunc.formatDate(Date.now())
        //     },
        //     ...me.comments,
        // ];
        me.$emit("handleSubmit", me.params);
        me.params = {};
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.h-comment {
  border: 1px solid;
  width: 100%;
  padding: 20px;
  border-radius: 10px;

  .border-avatar {
    background: #fff;
    border-radius: 50%;
  }

  .title-comment {
    font-weight: bold;
    font-size: 26px;
  }

  .input-comment {
    padding: 8px;
  }

  .ant-form-item-control-input-content {
    display: flex !important;
    justify-content: end !important;
  }

  .ant-btn-primary {
    background: linear-gradient(
      96.37deg,
      #19fb9b 2.78%,
      #1fcff1 50.89%,
      #9945ff 100%
    ) !important;
    width: 120px !important;
    height: 48px !important;
    border-radius: 32px !important;
    cursor: pointer !important;
  }

  .ant-list {
    color: #fff !important;
  }

  .ant-list-item {
    color: #fff !important;
  }

  .ant-list-header {
    border-bottom: 1px solid !important;
  }

  .comments {
    .comment {
      margin-bottom: 40px;
      position: relative;
    }

    .comment-content-info {
      .author {
        font-weight: bold;
        font-size: 18px;
      }

      padding: 20px;
      border: 1px solid;
      min-height: 120px;
      border-radius: 10px;

      .caret {
        position: absolute;
        top: 11px;
        right: 100%;
        left: -8px;
        display: block;
        width: 8px;
        height: 16px;
        pointer-events: none;
        content: " ";
        clip-path: polygon(0 50%, 100% 0, 100% 100%);

        &::before {
          background-color: var(--borderColor-default, var(--color-border-default));
        }
      }
    }

    .distance-comment {
      position: absolute;
      height: 40px;
      width: 1px;
      background: #fff;
      left: 100px;
    }
  }
}
</style>
